import { Contact } from './../../../admin/models/contact.model';
import { Component, OnInit, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, NavigationStart } from '@angular/router';
//import { GridOptions, ColDef, AllModules } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from 'ag-grid-community';

import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { ActionCellRendererComponent } from '../../../common/components/ag-grid/action-cell-renderer.component';
import { dateComparator } from '../../../common/components/data-table/comparators/data-table.comparators';
import { RouterLinkRendererComponent } from '../../../common/components/ag-grid/router-link-renderer.component';

import { AuthService } from '../../../services/auth.service';
import { GridFormatterService } from '../../../common/services/grid-formatter.service';
import { LoaderService } from '../../../common/services/loader.service';
import { WorkOrderService } from '../../../common/services/work-order.service';

import { UserIdentity } from '../../../models/user-identity.model';
import { WorkOrderStatus, WorkOrderType, WorkOrderWithAssignments } from '../../../common/models/work-order.model';

@Component({
    selector: 'work-order-widget',
    templateUrl: './work-order-widget.component.html',
    styleUrls: ['./work-order-widget.component.scss'],
    standalone: false
})
export class WorkOrderWidget implements OnInit {
    @Input() widgetTitle: string;


	assignToMeGridOptions: GridOptions;
	assignToMeGridApi?: GridApi;
	assignToGroupGridOptions: GridOptions;
	assignToGroupGridApi?: GridApi;
	assignByMeGridOptions: GridOptions;
	assignByMeGridApi?: GridApi;
    subscriptions: Subscription = new Subscription();

    columnAssignedTo: ColDef = {
        headerClass: "wrapped",
        headerName: 'Assigned to',
        headerTooltip: 'Assigned to',
        field: 'assignee',
        tooltipValueGetter: this.nameFormatter(),
        valueGetter: this.nameFormatter(),
        filterValueGetter: this.nameFormatter(),
        minWidth: 200,
        maxWidth: 250,
    };

    columnCompany: ColDef = {
        headerClass: "wrapped",
        headerName: 'Company Name',
        headerTooltip: 'Company Name',
        field: 'companyName',
        tooltipField: 'organizationName',
        minWidth: 175,
        maxWidth: 250
    }

    columnDueDate: ColDef = {
        headerClass: "wrapped",
        headerName: 'Due Date',
        headerTooltip: 'Due Date',
        field: 'dueDate',
        tooltipValueGetter: this.formatterService.formatDate('dueDate'),
        valueGetter: this.formatterService.formatDate('dueDate'),
        comparator: dateComparator,
        filter: false,
        minWidth: 125,
        maxWidth: 125,
    };

    columnEdit: ColDef = {
        headerClass: "wrapped",
        headerName: 'Edit',
        headerTooltip: 'Edit',
        filter: false,
        sortable: false,
        cellRenderer: RouterLinkRendererComponent,
        cellRendererParams: {
            url: '/common/work-order',
            idField: 'id',
            text: 'Edit'
        },
        minWidth: 100,
        maxWidth: 125,
    };

    columnStatus: ColDef = {
        headerClass: "wrapped",
        headerName: 'Status',
        headerTooltip: 'Status',
        field: 'status',
        tooltipValueGetter: this.statusFormatter(),
        valueGetter: this.statusFormatter(),
        filterValueGetter: this.statusFormatter(),
        minWidth: 150,
        maxWidth: 175
    };

    columnTitle: ColDef = {
        headerClass: "wrapped",
        headerName: 'Title',
        headerTooltip: 'Title',
        field: 'title',
        tooltipField: 'title',
        cellRenderer: ActionCellRendererComponent,
        cellRendererParams: {
            textField: 'title',
            action: this.showDetail()
        },
        minWidth: 150,
        maxWidth: 200
    };

    columnWorkOrderType: ColDef = {
        headerClass: "wrapped",
        headerName: 'Type',
        headerTooltip: 'Type',
        field: 'type',
        tooltipValueGetter: this.workOrderTypeFormatter(),
        valueGetter: this.workOrderTypeFormatter(),
        filterValueGetter: this.workOrderTypeFormatter(),
        minWidth: 125
    };

    data: any;
    isAdhocWorkOrder: boolean;
    selectedItem: any;
    showCompletedItems: boolean = false;
    showingDetail: boolean = false;
    statusEnum = WorkOrderStatus;
    types: any;
    workOrderTypeEnum = WorkOrderType;

    //Only downside is this needs kept in same order as actual work order enum
    prettyGridWorkOrderTypes = [
        "Ad Hoc",
        "Permit",
        "Review",
        "Ad Hoc Review",
        "Review Expedite",
        "Accept Application",
        "Certified Mail",
        "StandardMail",
        "Scan Documents",
        "Resubmit"
    ];

    public assignToMeColumns = [this.columnTitle, this.columnCompany, this.columnStatus, this.columnDueDate, this.columnWorkOrderType];
    public assignToGroupColumns = [this.columnTitle, this.columnCompany, this.columnStatus, this.columnDueDate, this.columnAssignedTo, this.columnWorkOrderType];
    public assignByMeColumns = [this.columnTitle, this.columnCompany, this.columnStatus, this.columnDueDate, this.columnAssignedTo, this.columnEdit, this.columnWorkOrderType];

    get user(): UserIdentity {
        return this._authService.User;
    }

    constructor(
        public _authService: AuthService,
        public _datePipe: DatePipe,
        private formatterService: GridFormatterService,
        public _loader: LoaderService,
        public _router: Router,
        public _service: WorkOrderService
	) {
        this.formatterService.applyFilterKeyboardHintTooltips(this.assignToMeColumns);
        this.formatterService.applyFilterKeyboardHintTooltips(this.assignToGroupColumns);
        this.formatterService.applyFilterKeyboardHintTooltips(this.assignByMeColumns);
    }

    ngOnInit() {
        this.types = [
            WorkOrderType.AdHoc,
            WorkOrderType.AdHocReview,
            WorkOrderType.Permit,
            WorkOrderType.Review,
            WorkOrderType.ReviewExpedite,
            WorkOrderType.AcceptApplication,
            WorkOrderType.Resubmit
        ];

        this.refreshData();

        this.assignToMeGridOptions = <GridOptions>{
            columnDefs: this.assignToMeColumns,
            defaultColDef: { filter: true, sortable: true } as ColDef,
            enableBrowserTooltips: false,
            tooltipTrigger: 'focus',
            isExternalFilterPresent: () => true,
            doesExternalFilterPass: this.isRowForUser(this),
			onGridReady: (params) => {
				this.assignToMeGridApi = params.api;
				this.assignToMeGridApi.sizeColumnsToFit();
            },
            pagination: true,
            paginationAutoPageSize: true,
            headerHeight: 50
        };

        this.assignToGroupGridOptions = <GridOptions>{
            columnDefs: this.assignToGroupColumns,
            defaultColDef: { filter: true, sortable: true } as ColDef,
            enableBrowserTooltips: false,
            tooltipTrigger: 'focus',
            isExternalFilterPresent: () => true,
            doesExternalFilterPass: this.isRowForGroup(this),
            pagination: true,
			paginationAutoPageSize: true,
			onGridReady: (params) => {
				this.assignToGroupGridApi = params.api;
				this.assignToGroupGridApi.sizeColumnsToFit();
			},
            headerHeight: 50
        };

        this.assignByMeGridOptions = <GridOptions>{
            columnDefs: this.assignByMeColumns,
            defaultColDef: { filter: true, sortable: true } as ColDef,
            enableBrowserTooltips: false,
            tooltipTrigger: 'focus',
            isExternalFilterPresent: () => true,
            doesExternalFilterPass: this.isRowByUser(this),
            pagination: true,
			paginationAutoPageSize: true,
			onGridReady: (params) => {
				this.assignByMeGridApi = params.api;
				this.assignByMeGridApi.sizeColumnsToFit();
			},
            headerHeight: 50
        };

        this._router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    create(): void {
        this._router.navigate(['/common', 'work-order']);
    }

    hideDetail(): void {
        this.showingDetail = false;
    }

    isRowByUser(component: any) {
        return (obj: any) => obj.data.creatorId === component.user.id && component.showIfCompleted(component, obj.data.status);
    }

    isRowForGroup(component: any) {
        return (obj: any) => component.user.groups.includes(obj.data.assignedGroupId) && component.showIfCompleted(component, obj.data.status);
    }

    isRowForUser(component: any) {
        return (obj: any) => obj.data.assignedUserId === component.user.id && component.showIfCompleted(component, obj.data.status);
    }

    nameFormatter() {
        return (obj: any) => {
            if (this.isRowForUser(this) && obj.data.assignee)
                return obj.data.assignee.lastName + ', ' + obj.data.assignee.firstName;
            if (this.isRowForGroup(this) && obj.data.assignedGroup)
                return obj.data.assignedGroup.displayName;
            return 'Unassigned';
        };
    }

    markComplete(changedItem: WorkOrderWithAssignments): void {
        this.selectedItem = changedItem;
        this.showingDetail = false;
        this.onCompletedChange();
    }

    onCompletedChange(): void {
        this.refreshData();
    }

    onTabClicked(): void {
        if (this.assignToGroupGridApi != null) {
            this.assignToGroupGridApi.sizeColumnsToFit();
        }
        if (this.assignByMeGridApi != null) {
            this.assignByMeGridApi.sizeColumnsToFit();
        }
    }

    refreshData(): void {
        this.showLoadingOverlays(true);
        this.subscriptions.add(this._service.getUserWorkOrders(this.user.id, this.types).subscribe({
            next: (workOrders) => {
                    this.data = workOrders;
                    this.showLoadingOverlays(false);
            }, 
            error: (error) => {
                console.log(error);
            }
        }));
    }

    showDetail() {
        return (obj: any) => {
            this.selectedItem = obj.data;
            this.showingDetail = true;
        }
    }

    showIfCompleted(component, status: WorkOrderStatus): boolean {
        return component.showCompletedItems || (status !== WorkOrderStatus.Completed && status !== WorkOrderStatus.Cancelled);
    }

    showLoadingOverlays(show: boolean): void {
        if (this.assignByMeGridOptions && this.assignByMeGridApi) {
            if (show) {
                this.assignByMeGridApi.setGridOption("rowData", []);
                this.assignByMeGridApi.setGridOption("loading", true);
            } else
                this.assignByMeGridApi.setGridOption("loading", false);
        }

        if (this.assignToGroupGridOptions && this.assignToGroupGridApi) {
            if (show) {
                this.assignToGroupGridApi.setGridOption("rowData", []);
                this.assignToGroupGridApi.setGridOption("loading", true);
            }
            else
                this.assignToGroupGridApi.setGridOption("loading", false);
        }

        if (this.assignToMeGridOptions && this.assignToMeGridApi) {
            if (show) {
                this.assignToMeGridApi.setGridOption("rowData", []);
                this.assignToMeGridApi.setGridOption("loading", true);
            }
            else
                this.assignToMeGridApi.setGridOption("loading", false);
        }
    }

    statusFormatter() {
        return (obj) => this.statusEnum[obj.data.status];
    }

    workOrderTypeFormatter() {
        return (obj) => this.prettyGridWorkOrderTypes[obj.data.type];
    }

    // workOrderTypeFormatter(component) {
    //   return (obj) => component.workOrderTypeEnum[obj.data.type];
    // }


}
